import {
  getGlobalCssUrl,
  getComponentCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavEnterpriseStylesTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavEnterprise--wc.css')}" rel="stylesheet" />
`
  return t
}

const getNavEnterpriseStyles = () => createNavEnterpriseStylesTemplate()
export { getNavEnterpriseStyles }
